import { useConfigInject, patchComponent } from '../_use';
import ConfigProviderMixin from '../_mixin/config-provider';
export function getElement(selector) {
  if (typeof selector === 'string') {
    return document.querySelector(selector);
  }
  if (!selector) {
    return null;
  }
  if (typeof selector === 'function') {
    return selector();
  }
  return null;
}
export const portalProps = {
  teleport: {
    type: [Function, Boolean, String],
    default: null
  }
};
export function PortalMixin() {
  let options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return patchComponent({
    props: portalProps,
    mixins: [ConfigProviderMixin],
    watch: {
      teleport: 'portal'
    },
    mounted() {
      this.portal();
    },
    beforeUnmount() {
      var _this$_container;
      if ((_this$_container = this._container) !== null && _this$_container !== void 0 && _this$_container.contains(this._el)) {
        this._container.removeChild(this._el);
      }
    },
    methods: {
      portal() {
        this._el = options !== null && options !== void 0 && options.ref ? this.$refs[options.ref] : this.$el;
        const {
          teleport
        } = useConfigInject(this, this.$options.name);
        this._container = teleport.value ? getElement(teleport.value) : this._el.parentNode;
        if (this._container && this._container !== this._el.parentNode) {
          this._container.appendChild(this._el);
        }
        if (options !== null && options !== void 0 && options.afterPortal) {
          options.afterPortal.call(this);
        }
      }
    }
  });
}